import { Get } from "../helpers/AxiosHelper";
import { Product, ReferralResult, ReferralStat, TopMinerUser, UIBundle, UserProduct, UserTransaction } from "../models/Models";

export const fetchUIBundle = async () => {
    const response = await Get<UIBundle>("/api/bundle");
    return response;
};

export const fetchProducts = async () => {
    const response = await Get<Product[]>("/api/products");
    return response;
};

export const fetchUserProducts = async () => {
    const response = await Get<UserProduct[]>("/api/user-products");
    return response;
};

export const fetchOrder = async (orderId: number) => {
    const response = await Get<UserTransaction>("/api/order/" + orderId);
    return response;
};


export const fetchReferralStats = async () => {
    const response = await Get<ReferralResult>("/api/referral-stats");
    return response;
};

export const fetchTransactions = async () => {
    const response = await Get<UserTransaction[]>("/api/transactions");
    return response;
};

export const fetchTopMiners = async () => {
    const response = await Get<TopMinerUser[]>("/api/top-miners");
    return response;
};